<div
  *ngIf="visible; else noVisibleTmp"
  class="carousel-button__wrapper"
  [class.carousel-button__wrapper_left-gradient]="type === 'backward-top' && variant === 'horizontal'"
  [class.carousel-button__wrapper_right-gradient]="type === 'forward-bottom' && variant === 'horizontal'"
  [class.carousel-button__wrapper_top-gradient]="type === 'backward-top' && variant === 'vertical'"
  [class.carousel-button__wrapper_bottom-gradient]="type === 'forward-bottom' && variant === 'vertical'"
  [class.carousel-button__wrapper_horizontal]="variant === 'horizontal'"
  [class.carousel-button__wrapper_vertical]="variant === 'vertical'"
>
  <button
    tuiIconButton
    type="button"
    class="carousel-button"
    appearance="floating"
    [style.border-radius.%]="100"
    size="m"
    [iconStart]="icon"
    (click)="scrollPanel.emit(type)"
  ></button>
</div>

<ng-template #noVisibleTmp>
  <div></div>
</ng-template>
